import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, EventEmitter, inject, Input, OnInit, Output, signal, TemplateRef, ViewChild, WritableSignal } from '@angular/core';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { ChecklistGroup, ChecklistItem, ChecklistResponse, DownloadFormPayload, DownloadFormPayloadItem } from '../../../interfaces/checklist.model';
import { PDFDiffChanges, PDFFormConfig } from '../../../interfaces/config';
import { CheckListService } from '../../../services/check-list.service';
import { ReferralDataService } from '../../../services/referral-data.service';
import { ButtonComponent } from "../../../shared/components/button/button.component";
import { ListTableComponent } from '../../../shared/components/list-table/list-table.component';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import { PROVIDER_TYPES, RADIO_YES_NO_OPTIONS, STATIC_JSON_DATA_PATH } from '../../../shared/constants/static-data.constants';
import { EditpdfComponent } from "../../editpdf/editpdf.component";
import { ChecklistHelperService } from '../../../services/checklist.helper.service';
import { EnrollmentDataService } from '../../../services/enrollment-data.service';
import { SectionsService } from '../../../services/sections.service';
import { LoggerService } from '../../../shared/services/logger.service';
import { Subject, Subscription } from 'rxjs';
import { PopupDialogComponent } from '../../../shared/components/popup-dialog/popup-dialog.component';
import { DialogComponent } from '../../../shared/components/dialog/dialog.component';
import { DialogConfig, DialogService } from '../../../shared/services/dialog.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { GridAction } from '../../../shared/components/list-table/grid-action.model';
import { MailFormService } from '../../../services/mail-form.service';
import { SendMailFormPostItem } from '../../../interfaces/mailform.interface';
import { UserDetails } from '../../../interfaces/user.interface';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { LeadDetailsService } from '../../../services/lead-details.service';
import {
  ChangesFreezeService,
  FREEZE_TYPE,
  ChangesFreezeState,
  UNFROZEN,
} from '../../../services/changes-freeze.service';
import { AccordionComponent } from '../../../shared/components/accordion/accordion.component';
import { AutoFocusHeaderDirective } from '../../../shared/directives/auto-focus-header.directive';
import { AuthorizationUtility } from '../../../shared/authorization/auth.utility';
import { AuthorizeButtonDirective } from "../../../shared/authorization/authorizeButton.directive";
import { TableRowActionsModel } from '../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../shared/interfaces/actions';
@Component({
  selector: 'ppl-pdf-form',
  standalone: true,
  imports: [
    CommonModule,
    NzAlertModule,
    ButtonComponent,
    NzCollapseModule,
    NzRadioModule,
    NzInputModule,
    NzSelectModule,
    NzDatePickerModule,
    EditpdfComponent,
    ListTableComponent,
    PopupDialogComponent,
    AccordionComponent,
    AutoFocusHeaderDirective,
    AuthorizeButtonDirective
],
  providers: [CheckListService],
  templateUrl: './pdf-form.component.html',
  styleUrl: './pdf-form.component.css'
})
export class PDFFormComponent implements OnInit {
  private dialogSvc = inject(DialogService);
  @Input() readonly?: boolean = false;
  @Input() isNewReferral = false;
  @Output() isMandatoryFormsCompleted = new EventEmitter<boolean>();
  @ViewChild('associationsDialog') associationDialogRef!: TemplateRef<any>;
  @ViewChild('pdfDialog') pdfDialogRef!: TemplateRef<any>;
  @ViewChild('confirmationDialog2') confirmationDialog2!: TemplateRef<any>;
  @ViewChild('confirmationDialogForEditingPaymentForm') confirmationDialogForEditingPaymentForm!: TemplateRef<any>;

  /** formMasterId of the Payment Method form */
  readonly PAYMENT_METHOD_FORM_MASTER_ID = 48;
  freezeState: ChangesFreezeState = UNFROZEN;
  /** Compliance-only: shows Freeze/Unfreeze on the Payment Method form row */
  canToggleFreeze = false;
  /** true when the active role may not edit because the account is frozen */
  changesBlocked = false;
  @ViewChild('freezeConfirmDialog') freezeConfirmDialog!: TemplateRef<any>;
  @ViewChild(EditpdfComponent) viewEditPDFComponent!: EditpdfComponent;
  @ViewChild('formHistoryDialog') formHistoryDialogRef!: TemplateRef<any>;
  @ViewChild('showChangesDialog') showChangesDialogRef!: TemplateRef<any>;
  @ViewChild('i9SaveDialog') i9SaveDialog!: TemplateRef<any>;

  highlightedFields: PDFDiffChanges[]=[];
  showConfirmationDialog = false;
  

  selectedItemToMail: WritableSignal<ChecklistItem | null> = signal(null);

  signForm = new Subject<object>();

  prvdrAssociations: any = [];
  associationDetailsData: any = {};

  date = '';
  radioOptions = RADIO_YES_NO_OPTIONS;
  showModal = false;
  showAssociationModal = false;
  modalBody = {
    associationModal: '',
    pdfViewer: ''
  };
  selectedForm: any;
  selectedAssociationForm: any;
  allPanelsExpanded = false;
  pdfConfig?: PDFFormConfig;
  previousPdfConfig?: PDFFormConfig
  pdfFile?: string;
  diffChanges?:string;
  pdfBlob?: Blob;
  checkListData: ChecklistGroup[] = [];
  providerAssociationChecklist?: ChecklistGroup[] = [];
  formData: any;
  program: any;
  disableSave = true;
  disableSign = true;
  errors: any = [];
  signature: any;
  signatureId: any;
  isSignAdded = false;
  checklistResponse?: ChecklistResponse;
  isParticipantFlow = false;
  userId = '';
  source = '';
  pplId = '';
  entry: string | null = '';
  cols: any[] = [];
  associatedPPLId?: string;
  selectedParticipantId?: number;
  selectedProviderType?: string;
  isSelf: boolean = true;
  selectedParticipant: any;
  customError = '';
  actions: any;
  participantTableActions: any;
  isPdfSubmitted: boolean = false;
  isI9Form: boolean = false;
  isW4Form: boolean = false;
  resignRequired = true;
  //The PDF viewer scrolls itself, so it must fit its dialog or the dialog body scrolls too (two scroll bars).
  //Changes dialog: .pdf-summary-wrapper is 80vh with 16px padding top and bottom
  readonly CHANGES_DIALOG_VIEWER_HEIGHT = 'calc(80vh - 32px)';
  isMobile = false;
  isAdmin = false;
  actionType = '';
  isHistory = false;
  readonlyHistory = this.readonly;
  activePanel: any;
  offerLettersGroup: any = { checklistName: 'Offer Letters', isActive: false };
  formHistoryChecklist: ChecklistGroup[] = [];
  confirmationDialogId: string = '';
  isPA = false;
  actionButtons: TableRowActionsModel = new TableRowActions({
    viewLatest: true,
  });
  buttonConfig = [
    {
      key: 'viewLatest',
      label: (rowData: any) => [55, 39, 41, 74, 44].includes(rowData?.formMasterId)
      ? 'View Last Signed Form'
      : 'View Last Completed Form',
      icon: '',
      disabled: (rowData: any) => rowData?.formStatus !== 'C',
      condition: (rowData: any) => this.actionButtons?.viewLatest && ([60, 55, 39, 41, 74, 44].includes(rowData.formMasterId)),
    }
  ];

  offerButtonConfig = [
    {
      key: 'viewLatest',
      label: (rowData: any) => 'View Last Signed Form',
      icon: '',
      disabled: (rowData: any) => rowData?.formStatus !== 'C',
      condition: (rowData: any) => true,
    }
  ];

  @Input() pageId: any;
  @Input() tabId: any;

  participantCols: any = [
    {
      "field": "formDesc",
      "header": "Form Name",
      "jsonpath": "formDesc",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "status",
      "header": "Form Status",
      "jsonpath": "status",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    }
  ]

  historyCols: any =[
    {
      "field": "createdBy",
      "header": "Last Updated By",
      "jsonpath": "createdBy",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "createdDate",
      "header": "Date Updated",
      "jsonpath": "createdDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "status",
      "header": "Form Status",
      "jsonpath": "status",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "signed",
      "header": "Signed/Acknowledged",
      "jsonpath": "signed",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    }
  ]

  //Offer letter history spans every county variant, so it adds a column naming the variant of each record
  offerLetterHistoryCols: any = [
    {
      "field": "offerLetterType",
      "header": "Offer Letter Type",
      "jsonpath": "offerLetterType",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    ...this.historyCols
  ]

  formHistoryCols: any = this.historyCols;

  summaryCols: any=[
    {
      "field": "path",
      "header": "Field",
      "jsonpath": "path",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "value",
      "header": "Original Value",
      "jsonpath": "value",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "field": "currentValue",
      "header": "New Value",
      "jsonpath": "currentValue",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    }
  ]

  participantAssociationActions: any = {
    "view": true
  }

  downloadAll() {
    this.handleDownload(this.checklistResponse?.checkList || []);
  }

  constructor(
    private checkListService: CheckListService,
    private referralService: ReferralDataService,
    private sectionsService: SectionsService,
    private logger: LoggerService,
    private checklistHelperService: ChecklistHelperService,
    private enrollmentDataService: EnrollmentDataService,
    private notificationService: NotificationService,
    private mailFormService: MailFormService,
    private userService: UserService,
    private storageService: StorageService,
    private dialogService: DialogService,
    private authUtility: AuthorizationUtility,
    private freezeService: ChangesFreezeService,
    private leadDetailsService: LeadDetailsService
  ) {

  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth < 768;
    const userDetails = this.userService.getUserDetails();
    if (!userDetails) {
      console.error('no user details found');
      return;
    }
    this.isAdmin = userDetails.usertype_lkp == 'FMS';
    this.program = this.userService.getSelectedProgram();
    const viewHistory = this.authUtility.isSectionEditable(this.pageId, this.tabId, 'Forms_History');
    const viewReturn = this.authUtility.isSectionEditable(this.pageId, this.tabId, 'Forms_Return');

    this.actions = {
      "edit": true,
      "download": true,
      "mail": !this.readonly,
      "history": viewHistory,
      "return": viewReturn
    }
    this.participantTableActions = { ...this.actions, "edit": false };
    this.entry = this.userService.getLeadEntry() ?? '';
    this.userId = this.storageService.getParticipantId() || this.storageService.getProviderId() || this.userService.getSelectedLead() || '';
    this.isParticipantFlow = this.userService.getLeadEntry() == 'participantEnrollment' || this.sectionsService.getFlow() == 'participantEnrollment';
    this.source = this.isParticipantFlow ? 'participant' : 'provider';
    this.loadData();
    this.getSignature(this.program.program_code, this.source, this.userId);
    this.isPA = this.userService.isSelectedRole('Employer (External)');
    this.loadFreezeState();
  }

  /** A frozen account also blocks editing the Payment Method form. */
  private loadFreezeState(isAfterUpdate = false): void {
    const accountId = Number(this.userId);
    if (!accountId || !this.program?.program_code) {
      return;
    }
    this.canToggleFreeze = this.freezeService.canToggleFreeze();
    this.freezeService
      .getFreezeState(
        this.program.program_code,
        this.freezeEnrollmentType(),
        accountId,
        FREEZE_TYPE.PAYMENT_METHOD,
        isAfterUpdate
      )
      .subscribe((state) => {
        this.freezeState = state;
        this.changesBlocked = this.freezeService.isBlocked(state);
        this.applyFreezeToRows();
      });
  }

  //derived from isParticipantFlow rather than entry: the backend reads any other value as provider
  private freezeEnrollmentType(): string {
    return this.isParticipantFlow ? 'participantEnrollment' : 'providerEnrollment';
  }

  /** Toggles the PAYMENT_METHOD freeze only; Contact Details is frozen independently. */
  toggleFreeze(): void {
    const freezing = !this.freezeState.frozen;
    const dialogConfig: DialogConfig = {
      title: 'Confirmation',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
      isOkText: 'Yes',
      cancelText: 'No',
    };
    this.dialogSvc.openDialog(
      this.freezeConfirmDialog,
      dialogConfig,
      () => this.confirmFreeze(freezing),
      () => { }
    );
  }

  private confirmFreeze(frozen: boolean): void {
    const accountId = Number(this.userId);
    this.freezeService
      .setFreeze(
        this.program.program_code,
        this.freezeEnrollmentType(),
        accountId,
        FREEZE_TYPE.PAYMENT_METHOD,
        frozen
      )
      .subscribe(() => this.loadFreezeState(true));
  }

  isPaymentFormBlocked(row: any): boolean {
    //same rule as Contact Details: blocked for internal staff, but Compliance and the account
    //holder keep their access
    return this.changesBlocked && row?.formMasterId === this.PAYMENT_METHOD_FORM_MASTER_ID;
  }

  /**
   * The desktop grids render Edit through the shared list-table, which greys it out from
   * rowData.disable, so the freeze has to be stamped onto each row. The mobile card layouts
   * bind isPaymentFormBlocked directly and need nothing here.
   *
   * Safe to call before or after the freeze state arrives: whichever of the two async loads
   * finishes last re-stamps the rows.
   */
  private applyFreezeToRows(): void {
    //Freeze/Unfreeze belongs on the live form rows only. History rows are a read-only record of
    //past versions, and list-table renders these row actions regardless of actionButtons, so the
    //history grid has to be excluded explicitly rather than relying on history mode.
    const liveGroups: any[] = [this.checkListData, this.providerAssociationChecklist];
    const allGroups: any[] = [...liveGroups, this.formHistoryChecklist];

    allGroups.forEach((groups: any) => {
      groups?.forEach((group: any) => {
        group?.items?.forEach((item: any) => {
          item.disable = this.isPaymentFormBlocked(item);
          item.actions = { ...item.actions, freeze: false, unfreeze: false };
        });
      });
    });

    liveGroups.forEach((groups: any) => {
      groups?.forEach((group: any) => {
        group?.items?.forEach((item: any) => {
          const showToggle = this.showFreezeToggle(item);
          item.actions = {
            ...item.actions,
            freeze: showToggle && !this.freezeState.frozen,
            unfreeze: showToggle && this.freezeState.frozen,
          };
        });
      });
    });
  }

  /**
   * Freeze/unfreeze events live in their own audit table rather than the form version log, so
   * they are fetched separately and folded into the Payment Method Form's history, newest
   * first. Other forms are untouched.
   */
  private mergePaymentFreezeHistory(row: any): void {
    const accountId = Number(this.userId);
    if (row?.formMasterId !== this.PAYMENT_METHOD_FORM_MASTER_ID
        || !accountId || !this.program?.program_code) {
      return;
    }
    this.leadDetailsService
      .getPaymentFormHistory(this.program.program_code, this.freezeEnrollmentType(), accountId)
      .subscribe((response: any) => {
        const freezeRows = (response?.responsedata ?? []).map((item: any) => ({
          createdBy: item.modifiedByName,
          createdDate: this.formatDateToAMPM(item.auditCreatedDate),
          //version rows report a form status; a freeze event reports its own state instead
          status: item.operation === 'FREEZE' ? 'Frozen' : 'Unfrozen',
          signed: '',
          path: '',
          value: '',
          //a freeze event has no form version behind it, so there is nothing to open or diff
          actions: { view: false, showChanges: false },
        }));
        const groups = [...(this.formHistoryChecklist ?? [])];
        if (!freezeRows.length || !groups.length) {
          return;
        }
        //one group per form, so the events belong to the first and only one
        groups[0] = {
          ...groups[0],
          items: [...(groups[0].items ?? []), ...freezeRows].sort(
            (a: any, b: any) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
          ),
        };
        this.formHistoryChecklist = groups;
      });
  }

  /** Compliance-only, and only on the Payment Method form row. */
  showFreezeToggle(row: any): boolean {
    return this.canToggleFreeze && row?.formMasterId === this.PAYMENT_METHOD_FORM_MASTER_ID;
  }

  loadData() {
    this.checkListService.getChecklist(this.program?.program_code, this.userId || '', this.isParticipantFlow).subscribe((data: any) => {
      if (data.responsedata) {
        this.checklistResponse = data.responsedata;
        this.checklistResponse?.checkList.forEach((checklist: any) => 
          {
            checklist['arialabel'] = checklist.formDesc + 'Status ' + (checklist.formStatus == 'C' ? 'Completed' : 'Not Completed');
          });
        if (this.checklistResponse) {
          this.pplId = this.checklistResponse.pplId;
          if (this.isParticipantFlow) {
            this.checkListData = this.checklistHelperService.buildChecklistDataForParticipant(this.checklistResponse.checkList, true);
          } else {
            this.checkListData = this.checklistHelperService.buildChecklistDataForProvider(this.checklistResponse.checkList, null, true, true);
          }

          this.checkListData.forEach((group: ChecklistGroup) => {
            group.items?.forEach((item: ChecklistItem) => {
              item.actions = { ...item.actions, edit: item.formMasterId !== 74 };
            });
          });
          this.applyFreezeToRows();

          if (this.isParticipantFlow) {
            this.updateMandatoryFormsCompleteStatus();
          }
        }
      }
    });

    if (!this.isParticipantFlow) {
      this.getGridHeaders();
      this.enrollmentDataService.getParticipantAssocChanged().subscribe((data: any) => {
        this.getAssociationDetails();
      })
    }
  }


  async getGridHeaders() {
    try {
      if (this.entry) {
        const tempCols = await this.sectionsService.getJsonConfigurationData(
          this.entry === 'participantEnrollment' ? STATIC_JSON_DATA_PATH.ASSOCIATIONS_DETAILS_HEADERS : STATIC_JSON_DATA_PATH.PROVIDER_ASSOCIATIONS_HEADERS, this.entry
        );
        // tempCols.columns.push({
        //   "field": "formStatusText",
        //   "header": "Form Status",
        //   "jsonpath": "formStatusText",
        //   "isDisplayedAtHeader": "y",
        //   "isSearchable": "n"
        // });
        console.log(tempCols.columns);
        this.cols = tempCols.columns;
      }
    } catch (e) {
      this.logger.debug('Communication logs - Error in getting column data', e);
    }
  }

  handleSign() {
    if (!this.disableSign) {
      this.signForm.next({
        isParticipant: this.isParticipantFlow,
        participantId: this.selectedParticipantId,
        providerType: this.selectedProviderType
      });
    }
    this.disableSign = true;
  }

  getSignature(program_code: string, type: string, id: string | null) {
    this.referralService.getSignature(program_code, type, id).subscribe((data: any) => {
      if (data?.responsedata && data?.responsedata.length) {
        const activeSign = data?.responsedata.find((data: any) => data.isActive);
        this.isSignAdded = true;
        this.signature = `data:image/png;base64,${activeSign?.signatureImageBase64}`;
        this.disableSign = false;
        this.signatureId = this.isParticipantFlow ? activeSign.participantSignatureId : activeSign.providerSignatureId;
      }
    })
  }

  getAssociationDetails() {
    this.enrollmentDataService.getAssociationsDetails(this.program.program_code, this.userId, this.isParticipantFlow).subscribe((response: any) => {
      const data = response.responsedata;
      if (this.isParticipantFlow) {
        for (const key in PROVIDER_TYPES) {
          this.associationDetailsData[key] = data[key] || [];
        }
      } else {
        this.prvdrAssociations = (data.participantAssociations ?? []).map((association: any) => ({
          ...association,
          arialabel: 'Consumer Association Forms'
        }));}

      // for (const checklist of this.prvdrAssociations) {
      //   if (checklist.formStatus == 'C') {
      //     checklist.formStatusText = "Completed"
      //   } else {
      //     checklist.formStatusText = "Not Completed"
      //   }
      // }

      this.prvdrAssociations = this.prvdrAssociations.filter((association: any) => association.associationStatus != 'Disassociated');

      this.updateMandatoryFormsCompleteStatus();
    });
  }

  isAssociationsCompleted() {
    let isCompleted = true;
    for (const checklist of this.prvdrAssociations) {
      if (checklist.formStatus != 'C') {
        isCompleted = false;
        break;
      }
    }

    return isCompleted;
  }

  action(event: GridAction, isAssociation: boolean, forceIgnore = false) {
    this.actionType = event.action;
    if (event.action === 'freeze' || event.action === 'unfreeze') {
      this.toggleFreeze();
      return;
    }
    if (event.action == 'edit') {
      //the button is already disabled when frozen; this stops any other path into the edit flow
      if (this.isPaymentFormBlocked(event.data)) {
        return;
      }
      if (!this.isNewReferral && !forceIgnore && event.data?.formMasterId == this.PAYMENT_METHOD_FORM_MASTER_ID) {
        this.handlePaymentFormEditConfirmation(event, isAssociation);
        return;
      }

      this.disableSave = true;
      if (isAssociation) {
        this.isSelf = false;
        this.handleAssociationCheckListClick(event.data)
      } else {
        this.isSelf = true;
        this.handleCheckListClick(event.data)
      }
    }
    else if (event.action == 'viewLatest') {
      this.disableSave = true;
      this.isSelf = true;
      this.readonly = true;
      this.handleCheckListClick(event.data, 'latestForm')
    }
    else if (event.action == 'download') {
      this.handleDownload([event.data]);
    }
    else if (event.action == 'view') {
      if(this.isHistory) {
        this.isSelf = true;
        this.handleCheckListClick(event.data, 'history')
      } else {
        this.disableSave = true;
        this.selectedParticipant = event.data;
        this.handleParticipantAssociationSelection(event.data)
      }
    } else if (event.action === 'requestMail') {
      this.selectedItemToMail.set(event.data);
      this.handleRequestMail();
    } else if (event.action == 'history') {
      this.actions = {
        "view": true,
        "showChanges": true
      }
      this.isHistory = true;
      this.disableSave = true;
      this.readonly = true;
      this.handleHistory(event.data)
    } 
    else if(event.action === 'showChanges'){
     
      this.handleShowChangesClick(event.data);
      
    }
    else if(event.action === 'return'){
      const payload = {
        programCode: this.program.program_code,
        userType: "IR",
        checklistItemId: event.data.checklistItemId,
        checklistItemDetailsId: event.data.checklistItemDetailId,
        formId: event.data.formMasterId,
        formName: event.data.formDesc
     } 
      this.checkListService.returnI9Form(payload, this.userId).subscribe((data: any)=>{
        this.loadData();
      })
    }
  }

  handleShowChangesClick(data: any) {
    this.selectedForm = data;
    const currentuser = this.selectedForm.details.filter((d: any) => d.associationId == -1);
    this.selectedProviderType = currentuser.length > 0 ? currentuser[0].type : '';
    this.showModal = true; 
    this.modalBody.pdfViewer = 'Changes - '+ data.formDesc;
    const dialogConfig: DialogConfig = {
      title: this.modalBody.pdfViewer,
      isOkText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    }
    this.dialogSvc.openDialog(this.showChangesDialogRef, dialogConfig, () => this.handleCancel(), () => this.handleCancel());
    const diffChangesEntry = data?.data.find((entry: { type: string; }) => entry.type === "DiffChanges");
    this.diffChanges = diffChangesEntry ? diffChangesEntry.value : null;
    this.highlightedFields = this.parseDiffChanges(this.diffChanges);
    if (data?.formDesc === 'Attestation of Health Assessment') {
      this.highlightedFields = this.highlightedFields?.filter(
        (field) => field?.path !== 'Personal Assistant Name Print'
      );
    }
    this.loadPDF(data, 'history');
    
    
  }



  handleHistory(data: any,fromClosedDialog?: boolean) {
    //the subscribe below shadows `data` with the response, so keep a handle on the row
    const selectedFormRow = data;
    this.showAssociationModal = true;
    this.modalBody.associationModal = 'History Of Forms - ' +data.formDesc; 
    this.selectedParticipantId = this.selectedParticipant?.participantId;
    this.selectedProviderType = this.selectedParticipant?.providerType;
    const dialogConfig: DialogConfig = {
      title: this.modalBody.associationModal,
      isOkText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    }

    const statusMap: Record<string, string> = {
      C: 'Completed',
      R: 'Form Returned'
    };

    this.checkListService.getCheckListHistory(this.program?.program_code, this.selectedParticipantId?`${this.selectedParticipantId}`:'', this.userId, this.selectedProviderType?this.selectedProviderType:'', data.checklistItemId, this.source)
  .subscribe((data) => {
    if (data.responsedata) {
      const checklist: ChecklistResponse = data.responsedata;
      if(this.selectedParticipant){
        this.associatedPPLId = checklist.pplId;
        this.selectedParticipant.providerPPLID = checklist.pplId;
        this.formHistoryChecklist = this.checklistHelperService
        .buildHistoryDataForProvider(checklist.checkList, this.selectedParticipant, true, false)
        .map(group => ({
          ...group,
          items: [...group.items]
            .map(item => ({
              ...item,
              createdDate: this.formatDateToAMPM(item.createdDate),
              modifiedDate: this.formatDateToAMPM(item.modifiedDate),
              status: statusMap[item.formStatus] || 'Not Completed'
            }))
            .sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime())
        }));
      }else{
        this.formHistoryChecklist = this.checklistHelperService
          .buildHistoryDataForProvider(checklist.checkList, data, true, true)
          .map(group => ({
            ...group,
            items: [...group.items]
              .map(item => ({
                ...item,
                createdDate: this.formatDateToAMPM(item.createdDate),
                modifiedDate: this.formatDateToAMPM(item.modifiedDate),
                status: statusMap[item.formStatus] || 'Not Completed'
              }))
              .sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime())
          }));
        }
      this.formHistoryCols = this.formHistoryChecklist.some(group => group.items.some(item => item.offerLetterType))
        ? this.offerLetterHistoryCols : this.historyCols;
      this.applyFreezeToRows();
      this.mergePaymentFreezeHistory(selectedFormRow);
    }
  });


    if (!fromClosedDialog) {
      this.dialogSvc.openDialog(this.formHistoryDialogRef, dialogConfig, () => this.handleCancelForHistory(), () => this.handleCancelForHistory());
    }
  }

  formatDateToAMPM(dateStr: string): string {
    const date = new Date(dateStr);
    const options: Intl.DateTimeFormatOptions = {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    return date.toLocaleString('en-US', options);
  }

  handleCancelForHistory(): void {
    this.isHistory = false;
    this.readonly = this.readonlyHistory;
    this.actions = {
      "edit": true,
      "download": true,
      "mail": !this.readonly,
      "history": true,
      "return": true
    }
    this.participantTableActions = { ...this.actions, "edit": false };
    this.loadData();
  }

  handleRequestMail() {
    const dialogConfig: DialogConfig = {
      title: 'Confirm Mail',
      isOkText: 'Mail Form',
      size: 'medium',
      position: 'top',
    }
    this.dialogSvc.openDialog(
      this.confirmationDialog2,
      dialogConfig,
      () => this.handleRequestMailClick(this.selectedItemToMail()),
      () => this.onCloseDialog()
    );
  }

  handlePaymentFormEditConfirmation(event: GridAction, isAssociation: boolean) {
    const dialogConfig: DialogConfig = {
      title: 'Warning: Payment Method Updates May Delay Electronic Payments',
      isOkText: 'I understand',
      size: 'medium',
      position: 'top',
      showOkButton: true,
      showButtons: false,
      showClose: true
    }
    this.confirmationDialogId = this.dialogSvc.openDialog(
      this.confirmationDialogForEditingPaymentForm,
      dialogConfig,
      () => this.onCloseConfirmationDialog(event, isAssociation),
      () => this.onCancelConfirmationDialog(event, isAssociation)
    );
  }

  handleParticipantAssociationSelection(selectedParticipant: any, fromClosedDialog?: boolean) {
    this.showAssociationModal = true;
    this.modalBody.associationModal = 'Consumer Association - ' + selectedParticipant.participantFirstName + ' ' + selectedParticipant.participantLastName + ' (' + selectedParticipant.participantPplId + ')';
    this.selectedParticipantId = selectedParticipant.participantId;
    this.selectedProviderType = selectedParticipant.providerType;
    const dialogConfig: DialogConfig = {
      title: this.modalBody.associationModal,
      isOkText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    }

    if (!fromClosedDialog) {
      this.dialogSvc.openDialog(this.associationDialogRef, dialogConfig, () => this.handleCancelForAssociation(), () => this.handleCancelForAssociation());
    }
    this.checkListService.getChecklistForParticipantAssociation(this.program?.program_code, selectedParticipant.providerId, selectedParticipant.participantId, selectedParticipant.providerType).subscribe((data: any) => {
      if (data.responsedata) {
        const checklist: ChecklistResponse = data.responsedata;
        checklist?.checkList.forEach((checklist: any) => 
        {
            checklist['arialabel'] = checklist.formDesc + 'Status ' + (checklist.formStatus == 'C' ? 'Completed' : 'Not Completed');
        });
        this.associatedPPLId = checklist.pplId;
        selectedParticipant.providerPPLID = checklist.pplId;
        this.providerAssociationChecklist = this.checklistHelperService.buildChecklistDataForProvider(checklist.checkList, selectedParticipant, true, false);
        this.applyFreezeToRows();
      }
    });
  }

  handleDownload(forms: ChecklistItem[]) {
    const pdfPayload: DownloadFormPayloadItem[] = [];
    forms.forEach(f => {
      if (f.formMasterId != 0) {
        const details = f.details.map(e => Object({ userType: e.type, primaryId: e.pplId }));
        if (this.source == 'participant' && details.filter((e: any) => e.userType == 'PTC').length == 0) {
          details.push(new Object({ userType: 'PTC', primaryId: this.pplId }));
        }
        const payload = {
          formId: f.formMasterId + '',
          checkListItemId: f.checklistItemId,
          checkListItemDtlsId: f.checklistItemDetailId,
          source: this.source,
          programCode: this.program?.program_code,
          languageCode: 'EN',
          prtcpntPrvdrIdAndTypes: details,
          formVersion: f.formVersion ?? 0
        };

        pdfPayload.push(payload);
      }
    });

    const formPayload: DownloadFormPayload = {
      forms: [...pdfPayload]
    };

    this.checkListService.downloadPDFForm(formPayload, this.source + '_forms.zip');
  }

  handleCheckListClick(form: ChecklistItem, from = '') {
    this.selectedForm = form;
    const currentuser = this.selectedForm.details.filter((d: any) => d.associationId == -1);
    this.selectedProviderType = currentuser.length > 0 ? currentuser[0].type : '';
    this.showModal = true;
    this.modalBody.pdfViewer = form.formDesc;
    const dialogConfig: DialogConfig = {
      title: this.modalBody.pdfViewer,
      isOkText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
      styleClass: 'fill-body',
    }
    this.dialogSvc.openDialog(this.pdfDialogRef, dialogConfig, () => this.handleCancel(from), () => this.handleCancel(from));

    this.loadPDF(form, from);
  }

  handleAssociationCheckListClick(form: ChecklistItem) {
    this.selectedAssociationForm = form;
    this.showModal = true;
    this.modalBody.pdfViewer = form.formDesc;
    const dialogConfig: DialogConfig = {
      title: this.modalBody.pdfViewer,
      isOkText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
      styleClass: 'fill-body',
    }
    this.dialogSvc.openDialog(this.pdfDialogRef, dialogConfig, () => this.handleCancel(), () => this.handleCancel());
    this.loadPDF(form);
  }

  handleCancel(from = '') {
    if(from === 'latestForm'){
      this.readonly = false;
    }
    this.showModal = false;
    this.pdfConfig = undefined;
    this.pdfFile = undefined;
    this.selectedForm = undefined;
    this.signForm = new Subject();
    this.disableSign = false;
    this.highlightedFields=[];
    this.diffChanges = undefined;
    this.previousPdfConfig = undefined;
    if (this.selectedParticipant) {
      this.handleParticipantAssociationSelection(this.selectedParticipant, true);
    } else {
      this.loadData();
    }
  }

  handleCancelForAssociation() {
    this.showModal = false;
    this.pdfConfig = undefined;
    this.pdfFile = undefined;
    this.selectedForm = undefined;
    this.selectedAssociationForm = undefined;
    this.showAssociationModal = false;
    this.providerAssociationChecklist = undefined;
    this.selectedParticipantId = undefined;
    this.selectedParticipant = undefined;
    this.associatedPPLId = undefined;
    this.signForm = new Subject();
    this.disableSign = false;
    this.loadData();
  }

  fieldsUpdated(event: any) {
    this.formData = event.data;
    this.errors = event.errors;
    this.disableSave = this.errors.length != 0 || event.customError != '';
    this.customError = event.customError;
  }

  updateMandatoryFormsCompleteStatus() {
    let isCompleted = true;
    for (const checklist of this.checkListData) {
      if (checklist.items.filter(e => e.mandatory && e.formStatus == 'P').length > 0) {
        isCompleted = false;
        break;
      }
    }

    for (const checklist of this.prvdrAssociations) {
      if (checklist.checklistStatus == 'P') {
        isCompleted = false;
        break;
      }
    }

    this.isMandatoryFormsCompleted.emit(isCompleted);
  }

  openI9SaveDialog() {
    const dialogConfig: DialogConfig = {
      title: 'Alert',
      isOkText: 'Ok',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: false,
      showOkButton: true
    };

    this.dialogSvc.openDialog(
      this.i9SaveDialog,
      dialogConfig,
      () => this.handlePdfSave(),
      () => this.handleI9Cancel()
    );
  }

  handleI9Cancel(){}

  handlePdfSave(){
    if (this.selectedParticipantId) {
      this.handleSaveAssociation();
      return;
    }

    if (this.errors.length == 0) {
      const checklistSaveResponse = this.generateSaveChecklistResponses();
      const payload = {
        type: this.source,
        checklistItems: checklistSaveResponse.filter(e => e != null)
      };
      this.checkListService.saveParticipantProviderForms(this.program?.program_code, this.userId, this.isParticipantFlow, payload).subscribe((response: HttpResponse<Blob>) => {
        if (response.status === 200) {
          this.loadPDFData(this.selectedForm);
          this.disableSave = true;
          this.isPdfSubmitted = true;

          this.viewEditPDFComponent.onFormSubmission();
        }
      });
    }
  }

  handleSave() {
    if(this.isI9Form && this.isPA){
        this.openI9SaveDialog();
    }
    else{
     this.handlePdfSave();
    }
  }

  handleSaveAssociation() {
    if (this.errors.length == 0 && this.providerAssociationChecklist && this.selectedParticipantId) {
      const checklistSaveResponse = this.generateSaveChecklistResponsesForAssociation(this.selectedParticipantId);
      const payload = {
        type: "participantProvider",
        checklistItems: checklistSaveResponse.filter(e => e != null)
      };
      this.checkListService.saveParticipantAssocaitionForms(this.program?.program_code,
        this.selectedParticipantId, this.userId, this.selectedProviderType || '', payload).subscribe((response: HttpResponse<Blob>) => {
          if (response.status === 200) {
            this.loadPDFData(this.selectedAssociationForm);
            this.disableSave = true;
            this.isPdfSubmitted = true;

            this.viewEditPDFComponent.onFormSubmission();
          }
        });
    }
  }

  generateSaveChecklistResponses() {
    const checklist: any[] = [];
    if (this.selectedForm) {
      const currentuser = this.selectedForm.details.filter((d: any) => d.associationId == -1);
      checklist.push(new Object({
        checklistId: this.selectedForm.checklistItemId,
        checklistDetailId: this.selectedForm.checklistItemDetailId,
        participantId: this.isParticipantFlow ? this.userId : '',
        providerId: !this.isParticipantFlow ? this.userId : '',
        providerType: currentuser.length > 0 ? currentuser[0].type : '',
        associationId: this.selectedForm.details.filter((e: any) => e.associationId != -1).map((d: any) => d.associationId),
        formValue: this.formData,
      }));
    }

    return checklist;
  }

  generateSaveChecklistResponsesForAssociation(participantId: number) {
    const checklist: any[] = [];
    if (this.selectedAssociationForm) {
      checklist.push(new Object({
        checklistId: this.selectedAssociationForm.checklistItemId,
        checklistDetailId: this.selectedAssociationForm.checklistItemDetailId,
        participantId: participantId,
        providerId: this.userId,
        providerType: this.selectedProviderType,
        associationId: this.selectedAssociationForm.details.filter((d: any) => d.associationId != -1).map((d: any) => d.associationId),
        formValue: this.formData,
      }));
    }
    return checklist;
  }

  loadPDF(form: ChecklistItem, from = '') {
    this.errors = [];
    this.customError = '';
    this.formData = undefined;
    this.isPdfSubmitted = form.formStatus == 'C';
    this.isI9Form = form.formDesc.trim().toLowerCase() == 'USCIS Form I9'.toLowerCase();
    this.isW4Form = form.formDesc.trim().toLowerCase() == 'IRS Form W4'.toLowerCase();
    if (this.isI9Form) {
      this.resignRequired = !this.isAdmin;
    } else {
      this.resignRequired = true;
    }
    const versionId = from === 'latestForm' ? form.activeFormVersion : form.formVersion;
    this.checkListService.getPDF(this.program?.program_code, form.formMasterId, versionId, 'EN').subscribe((response: HttpResponse<Blob>) => {
      if (response.body) {
        const blob = new Blob([response.body], { type: response.body.type });
        this.pdfBlob = blob;
        this.pdfFile = window.URL.createObjectURL(blob);
      }
    });

    this.loadPDFData(form, from);
  }

  loadPDFData(form: ChecklistItem, from = '') {
    this.checkListService.getFormData(this.program?.program_code,
      form,
      this.source, this.pplId, from).subscribe(response => {
        if (response?.responsedata) {
          this.pdfConfig = {
            fields: response?.responsedata.Form_Fields,
            form_description: form.formDesc,
            form_id: form.formMasterId + '',
            form_name: form.form_name,
            is_mandatory: false
          };
          this.getHighlightedFields();
          this.setPreviousValues(form, from);
        }
      }); 
     
  }

  getHighlightedFields() {
    if (this.pdfConfig) {
      // Step 1: Filter out unwanted patches
      this.highlightedFields = this.highlightedFields.filter(patch => {
        // Try to find matching parent field
        const match = this.pdfConfig?.fields.find(field => field.businessName === patch.path);

        if (match) {
          if (
            patch.op === 'add' &&
            (match.fieldType === 'PDCheckBox' || match.fieldType === 'PDRadioButton') &&
            match.value === 'Off'
          ) {
            return false; // Remove patch
          }
          return true;
        } else {
          if (this.pdfConfig) {
            for (const field of this.pdfConfig.fields) {
              const childMatch = field.childFields?.find(child => child.fieldId === patch.path);
              if (
                patch.op === 'add' &&
                (field.fieldType === 'PDCheckBox' || field.fieldType === 'PDRadioButton') &&
                childMatch?.value === 'Off'
              ) {
                return false; // Remove patch
              }
            }
          }
          return true;
        }
      });


      // Step 2: Process remaining highlighted patches
      for (const patch of this.highlightedFields) {
        const match = this.pdfConfig.fields.find(field => field.businessName === patch.path);

        if (match?.fieldId && match?.fieldType === "CustomSignature") {
          patch["currentValue"] = patch["value"];
        }

        if (patch.op === 'add') {
          patch["value"] = "-";
        }

        if (match?.fieldId) {
          if (match?.fieldId !== "Personal Assistant's Signature" && match?.fieldId !== 'Signature/Acceptance of Offer') {
          patch["fieldId"] = match.fieldId;
          patch["currentValue"] = match.value;
          }
        } else {
          for (const field of this.pdfConfig.fields) {
            const childMatch = field.childFields?.find(child => child.fieldId === patch.path);
            if (childMatch?.fieldId) {
              patch["fieldId"] = childMatch.fieldId;
              patch["currentValue"] = childMatch.value;
              break;
            }
          }
        }
      }
    }
  }

  async setPreviousValues(form: ChecklistItem, from = '') {
    const checklistItems = this.formHistoryChecklist?.[0]?.items || [];
    const currentIndex = checklistItems.findIndex(i => i.checklistId === form.checklistId);
    if (currentIndex === -1 || !checklistItems[currentIndex + 1]) {
      return;
    }
    const previousForm = checklistItems[currentIndex + 1];

    try {
      this.previousPdfConfig = await this.loadPDFDataForPrevious(previousForm, from);
      if (this.previousPdfConfig) {
        for (const patch of this.highlightedFields) {
          const prev = this.previousPdfConfig.fields.find(field => field.businessName === patch.path);
          if (prev?.fieldId) {
            patch["value"] = prev.value || '-';
          } else {
            for (const field of this.previousPdfConfig.fields) {
              const childMatch = field.childFields?.find(child => child.fieldId === patch.path);
              if (childMatch?.fieldId) {
                patch["value"] = childMatch.value;
                break;
              }
            }
          }
        }
      }
    } catch (error) {
      console.error('Failed to load previous form config:', error);
    }
  }

  loadPDFDataForPrevious(previousForm: ChecklistItem, from = ''): Promise<PDFFormConfig> {
  return new Promise((resolve, reject) => {
    this.checkListService.getFormData(this.program?.program_code, previousForm, this.source, this.pplId, from)
      .subscribe({
        next: (response) => {
          if (response?.responsedata) {
            const config: PDFFormConfig = {
              fields: response.responsedata.Form_Fields,
              form_description: previousForm.formDesc,
              form_id: previousForm.formMasterId + '',
              form_name: previousForm.form_name,
              is_mandatory: false
            };
            resolve(config);
          } else {
            reject('No data found');
          }
        },
        error: (err) => reject(err)
      });
  });
}



  parseDiffChanges(raw?: string): PDFDiffChanges[] {
    const regex = /op:\s*(\w+);\s*path:\s*"?\/?([^"]+)";\s*value:\s*"([^"]*)"/g;
    let showDiff:PDFDiffChanges[] =[];
    if(raw){
      showDiff = Array.from(raw.matchAll(regex)).map(match => ({
        op: match[1],
        path: this.decodeJsonPointerPath(match[2]),
        value: match[3]
      }));
    }

    return showDiff;
  }

  decodeJsonPointerPath(path: string) {
    return path.replace(/~1/g, '/').replace(/~0/g, '~');
}

  hideAll() {
    this.checkListData.forEach(group => {
      group.isActive = false;

      this.toggleCollapsePanel(group, false);
    });
  }

  expandAll() {
    this.checkListData.forEach(group => {
      group.isActive = true;

      this.toggleCollapsePanel(group, true);
    });
  }

  toggleCollapsePanel(group: ChecklistGroup, activate: boolean) {
    group.isActive = activate;
    if (group.children && group.children.length > 0) {
      group.children.forEach(c => {
        this.toggleCollapsePanel(c, activate);
      })
    }
  }

  isPanelActive(group: ChecklistGroup): boolean {
    return this.isMobile ? true : group.isActive;
  }

  onPanelHeaderKeyPress(group: ChecklistGroup) {
    group.isActive = !group.isActive;
  
    if (group.isActive) {
      setTimeout(() => {
        const panelEl = document.querySelector(
          `[data-checklist-id="${group.checklistName}"]`
        );
        const focusTarget = panelEl?.querySelector(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        ) as HTMLElement;
        focusTarget?.focus();
      }, 100);
    }
  }

  getErrorMessage(error: any) {
    switch (error.errorName) {
      case 'required':
        return this.generateMessage(error.businessName);
      default:
        return 'unknown error ' + error.errorName;
    }
  }

  generateMessage(businessName: string) {
    if (businessName == 'Social Security Number') {
      return `Please add your Social Security Number. Enter nine numbers only, no dashes (Example: 123456789).`;
    }

    if (businessName == 'Date of Birth') {
      return `Please add Date of Birth to your profile under 'Demographics' in 'Basic Information' tab before completing this form.`;
    }

    return `${businessName} is required`;
  }

  showMailAllDialog() {
    this.showConfirmationDialog = true
  }

  handleConfirmMailAll() {
    const entityId = this.userService.getSelectedLead()!;
    const selectedProgram = this.program.program_code;
    const entityType = this.isParticipantFlow ? 'participant' : 'provider'

    this.showConfirmationDialog = false
    // TODO: Add proper types
    const formsToMail: SendMailFormPostItem[] = []

    this.checkListData.forEach(checklist => {
      checklist.items.forEach(item => {
        if (item.status !== "Completed" && item.formMasterId !== 50 && item.formMasterId !== 52) {
          formsToMail.push(
            {
              entityId,
              entityType,
              pplId: this.pplId || this.associatedPPLId || "",
              formMasterId: item.formMasterId,
              checklistDetails: item.details
            }
          )
        }
      })
    })
    // TODO: Wrap in a try/catch, only show success alert on successful call
    if (formsToMail.length === 0) {
      this.notificationService.alert(
        'warning',
        'Warning',
        'There are no forms to mail.'
      );
      return
    }
    this.mailFormService.sendMailForms(formsToMail, selectedProgram, entityId, entityType).subscribe(() => {
      this.notificationService.alert(
        'success',
        'Success',
        'All forms were successfully staged for mailing!'
      );
      this.mailFormService.triggerRefresh();
    });

  }

  handleRequestMailClick(formData: ChecklistItem | null) {
    if (!formData) return;
    const entityId = this.userService.getSelectedLead()!;
    const selectedProgram = this.program.program_code;
    const entityType = this.isParticipantFlow ? 'participant' : 'provider'
    this.selectedItemToMail.set(null);
    if (formData.formMasterId === 50 || formData.formMasterId === 52) {
      this.notificationService.alert(
        'warning',
        'Warning',
        'This form type is not supported for mailing.'
      );
      return
    }
    const formToMail: SendMailFormPostItem[] = [
      {
        entityId,
        entityType,
        pplId: this.pplId || this.associatedPPLId || "",
        formMasterId: formData.formMasterId,
        checklistDetails: formData.details
      }
    ]
    this.mailFormService.sendMailForms(formToMail, selectedProgram, entityId, entityType).subscribe(() => {
      this.notificationService.alert(
        'success',
        'Success',
        'Form was successfully staged for mailing!'
      );
      this.mailFormService.triggerRefresh();
    });
  }

  onCloseDialog() {
    this.showConfirmationDialog = false;
    this.selectedItemToMail.set(null);
  }

  onCloseConfirmationDialog(event: GridAction, isAssociation: boolean) {
    this.dialogService.closeDialog(this.confirmationDialogId);
    this.confirmationDialogId = '';
    this.action(event, isAssociation, true);
  }

  onCancelConfirmationDialog(event: GridAction, isAssociation: boolean) {
    this.dialogService.closeDialog(this.confirmationDialogId);
    this.confirmationDialogId = '';
  }

  updateChecklistActivity(checklistGroup: any) {
    checklistGroup.isActive = !checklistGroup.isActive;
  }
}